import { createContext } from 'react';
import { action, decorate, observable } from 'mobx';
import { FamilyAgent } from 'agents';
import { commonStore } from './common';

interface Family {
    admin: User | null;
    members: User[] | null;
}

interface User {
    uid: string;
    username: string;
    profile_pic_link: string;
}

class FamilyStore {
    readonly defaultFamily: Family = {
        admin: null,
        members: null,
    };

    family: Family = this.defaultFamily;
    isAdmin: boolean = false;

    retrieveFamily() {
        return FamilyAgent.family()
            .catch((e) => {
                console.log('YS', e);
            })
            .then((family) => familyStore.setFamily(family));
    }

    setFamily(family: any) {
        const { user } = commonStore;
        this.isAdmin = user.id === family.owner.uid;
        const admin: User = family.owner;
        let members: User[] = family.members;
        this.family = {
            admin: admin,
            members: members,
        };
    }

    addMember(member: string) {
        const data = { identifier: member };
        return FamilyAgent.addMember(data);
    }

    removeMember(member: string) {
        const data = { identifier: member };
        return FamilyAgent.removeMember(data);
    }

    leave() {
        return FamilyAgent.leave().then(() => {
            this.family = this.defaultFamily;
        });
    }
}

decorate(FamilyStore, {
    family: observable,
    isAdmin: observable,
    retrieveFamily: action,
    addMember: action,
    removeMember: action,
    leave: action,
});

export const familyStore = new FamilyStore();
export default createContext(familyStore);
